import Image from 'next/image';
import React from 'react';
import { Container } from '../../components';
import styles from './design-sketching.module.css';

export default function DesignSketching() {
  return (
    <section className={styles.root}>
      <Container>
        <h2 className={styles.title} id="sketching">
          Sketching
        </h2>
        <div className={styles.row}>
          <p className={styles.text}>
            We are like artists who sketch before creating a masterpiece. The
            first step is to listen to you and to hear. The most important is
            your initial idea and how you strive to differ from your
            competitors. We create the mind maps, find out the main aspects of
            the project, discuss possible features together and approve the
            final scope with you in order to move forward.
          </p>
          <div className={styles.box}>
            <span className={styles.counter}>01</span>
            <span className={styles.subtitle}>Sketching</span>
          </div>
        </div>
      </Container>
      <div className={styles.image}>
        <Image
          alt="Sketching banner"
          width={1920}
          height={560}
          objectFit="cover"
          src="/design/sketching/hands-min.jpg"
        />
      </div>
      <div className={styles.imageMob}>
        <Image
          alt="Mobile sketching banner"
          width={750}
          height={294}
          objectFit="cover"
          src="/design/sketching/hands-mob-min.jpg"
        />
      </div>
      <div className={styles.footer}>
        <Container>
          <div className={styles.end}>
            <p className={styles.helper}>From the drafts to the app</p>
            <p className={styles.subhelper}>
              After the first sketches are done we start the detailing process.
            </p>
            <div className={styles.one}>1</div>
            <div className={styles.two}>2</div>
            <div className={styles.lines}>
              <Image
                alt="dashed lines"
                width={865}
                height={256}
                src="/design/lines@2x.png"
              />
            </div>
            <div className={styles.linesMob}>
              <Image
                alt="mobile dashed lines"
                width={690}
                height={318}
                src="/design/lines-mobile@2x.png"
              />
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}
